import { render, staticRenderFns } from "./DepartmentsIntro.vue?vue&type=template&id=087f642e&scoped=true"
import script from "./DepartmentsIntro.vue?vue&type=script&lang=js"
export * from "./DepartmentsIntro.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsIntro.vue?vue&type=style&index=0&id=087f642e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087f642e",
  null
  
)

export default component.exports